import { BaseExporter } from '../base/BaseExporterMapping.js';
import PanelService from '../../../../../services/panelService.js';
import campaignValues from '../../../../../utils/campaignValues';
import NumberRounding from '../../../../../utils/numberRounding.js';
import { CLASSIC_PANEL_STATUS } from '../../../../../constants/enums.js';

export default class SwedishExporter extends BaseExporter {
    formatSpotLengths(spotLengths = []) {
        return [...spotLengths || []]
            .sort((a, b) => (typeof a === 'object' ? a.spotLength - b.spotLength : a - b))
            .map(item => typeof item === 'object' ? item.spotLength : item)
            .join(', ');
    }

    calculateDeliveredPanels(panels, targetSoV, parameters) {
        if (!panels) return { idsPanels: '', sovScreens: '' };

        return {
            idsPanels: PanelService.getIDSPanels(panels).length,
            sovScreens: PanelService.getPanelsThatMatchesTargetSoV(
                targetSoV,
                parameters.playSuccessLimit / 100.0,
                parameters.soVNumberOfDecimals,
                panels,
                true
            ).length
        };
    }

    export(parameters) {
        const baseData = this.getBaseData();
        const metrics = this.getCampaignMetrics();
        const isPlayCampaign = campaignValues.isPlayCampaign(this.orderline.type);
        const deliveredPlays = this.deliveryData?.playData || {};
        const deliveredPostings = this.deliveryData?.postingData || {};

        let uniquePostingPanels = [];
        if (!isPlayCampaign && deliveredPostings.length > 0) {
            uniquePostingPanels = deliveredPostings.reduce((acc, posting) => {
                const panels = posting.panels || [];
                panels.forEach(panel => {
                    if (panel.status !== null && panel.status.toLowerCase() === CLASSIC_PANEL_STATUS.POSTED && !acc.some(p => p.panelId === panel.panelId)) {
                        acc.push(panel);
                    }
                });
                return acc;
            }, []);
        }

        const { idsPanels, sovScreens } = this.calculateDeliveredPanels(
            isPlayCampaign ? deliveredPlays?.plays?.panels || [] : uniquePostingPanels,
            this.orderline.targetSoV,
            parameters
        );

        const exportData = {
            ...baseData,
            'Estimated EA-VAC': metrics.estimatedEAVAC,
            'Delivered EA-VAC': metrics.deliveredEAVAC,
            'Delivered 10sec EA-VAC': this.delivered.totalAlternateVAC || 0,
            'Estimated Plays': this.orderline.targetPlays || 0,
            'Delivered Plays': this.delivered.plays || 0,
            'Estimated SOV': NumberRounding.round(this.orderline.targetSoV * 100.0, 2) || 0,
            'Delivered SOV': NumberRounding.round(this.delivered.soV * 100.0, 2) || 0,
            'Estimated Panels': metrics.estimatedPanels,
            'Delivered Panels': metrics.deliveredPanels,
            'Estimated Spot length': this.formatSpotLengths(deliveredPlays.aidaSpotLengths),
            'Delivered Spot length': this.formatSpotLengths(deliveredPlays.spotlengths),
            'Delivered No.of panels in IDS': idsPanels,
            'Delivered No of panels delivered over 97%': sovScreens
        };

        return this.filterByPromiseType(exportData, baseData);
    }
}